import { render, staticRenderFns } from "./modal-wind.vue?vue&type=template&id=627fdf79&"
import script from "./modal-wind.vue?vue&type=script&lang=js&"
export * from "./modal-wind.vue?vue&type=script&lang=js&"
import style0 from "./modal-wind.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCarousel } from 'vuetify/lib/components/VCarousel';
import { VCarouselItem } from 'vuetify/lib/components/VCarousel';
installComponents(component, {VCarousel,VCarouselItem})
